import { graphql, useStaticQuery } from 'gatsby';

const usePodcastImages = () => {
  const { allContentfulImage } = useStaticQuery(graphql`
    query {
      allContentfulImage(
        filter: {
          contentful_id: {
            in: [
              "5R16EKTe7X17dfT6x12ApD" #toolbox for the trades
              "EEIWDwVxCD1KyKqilwzVE" #podcast mark
            ]
          }
        }
      ) {
        edges {
          node {
            contentful_id
            internalName
            alt
            image {
              file {
                url
              }
            }
          }
        }
      }
    }
  `);

  return allContentfulImage.edges;
};

export default usePodcastImages;
